import { action, makeObservable, observable } from 'mobx';
import { JACK_POT_AMOUNT_KEY } from '../core/constants/gameConstants';

class JackPotStore {
  jackpotWinnerInfo = [];

  jackPotData = [];

  remainingJackpotCards = [];

  jackpotAmounts = {};

  jackpotSceneAmounts = {};

  jackpotWinInfo = {};

  hasJackPot = false;

  isShowJackpot = false;

  initialBonusSpinInfo = {};

  jackPotExpireTime = 300;

  isShowJackPotScene = false;

  isShowJackPotWinPopup = false;

  jackpotAmountIsVisible = false;

  isAllowDoJackpotAction = true;

  isExpiredJackpotCards = false;

  isWinMoveAndScaleSymbolComplete = false;

  winCard = null;

  openedJackpotCardCount = { 1: 0, 2: 0, 3: 0, 4: 0 };

  constructor() {
    makeObservable(this, {
      winCard: observable,
      hasJackPot: observable,
      isShowJackpot: observable,
      jackPotData: observable.deep,
      jackPotExpireTime: observable,
      isShowJackPotScene: observable,
      jackpotAmounts: observable.deep,
      jackpotSceneAmounts: observable.deep,
      jackpotWinInfo: observable.deep,
      isExpiredJackpotCards: observable,
      isShowJackPotWinPopup: observable,
      isAllowDoJackpotAction: observable,
      jackpotAmountIsVisible: observable,
      jackpotWinnerInfo: observable.deep,
      initialBonusSpinInfo: observable.deep,
      remainingJackpotCards: observable.deep,
      openedJackpotCardCount: observable.deep,
      isWinMoveAndScaleSymbolComplete: observable,
      setWinCard: action.bound,
      setHasJackPot: action.bound,
      setJackPotData: action.bound,
      setIsShowJackpot: action.bound,
      reSetJackpotData: action.bound,
      setJackpotWinInfo: action.bound,
      updateJackpotData: action.bound,
      setJackpotAmounts: action.bound,
      updateJackpotAmounts: action.bound,
      setJackpotWinnerInfo: action.bound,
      setJackPotExpireTime: action.bound,
      setIsShowJackpotScene: action.bound,
      setInitialBonusSpinInfo: action.bound,
      setIsExpiredJackpotCards: action.bound,
      setIsShowJackPotWinPopup: action.bound,
      showRemainingJackpotCards: action.bound,
      setIsAllowDoJackpotAction: action.bound,
      setOpenedJackpotCardCount: action.bound,
      setJackpotAmountIsVisible: action.bound,
      resetOpenedJackpotCardCount: action.bound,
      setIsWinMoveAndScaleSymbolComplete: action.bound,
    });
  }

  setOpenedJackpotCardCount(id) {
    this.openedJackpotCardCount[id] += 1;
  }

  resetOpenedJackpotCardCount() {
    Object.keys(this.openedJackpotCardCount).forEach((key) => {
      this.openedJackpotCardCount[key] = 0;
    });
  }

  setWinCard(cardNumber) {
    this.winCard = cardNumber;
  }

  setIsAllowDoJackpotAction(bool) {
    this.isAllowDoJackpotAction = bool;
  }

  setIsWinMoveAndScaleSymbolComplete(bool) {
    this.isWinMoveAndScaleSymbolComplete = bool;
  }

  reSetJackpotData() {
    this.setWinCard(null);
    this.setJackPotData([]);
    this.setJackpotWinInfo({});
    this.setIsShowJackpotScene(false);
    this.setIsAllowDoJackpotAction(true);
    this.setIsShowJackPotWinPopup(false);
    this.setJackPotExpireTime(300);
    this.setIsWinMoveAndScaleSymbolComplete(false);
    this.setIsExpiredJackpotCards(false);
  }

  setHasJackPot(bool) {
    this.hasJackPot = bool;
  }

  setJackPotData(data) {
    this.jackPotData = data;
  }

  setIsShowJackpot(bool) {
    this.isShowJackpot = bool;
  }

  setIsShowJackpotScene(bool) {
    this.isShowJackPotScene = bool;
    this.jackpotSceneAmounts = bool ? this.jackpotAmounts : {};
  }

  setIsShowJackPotWinPopup(bool) {
    this.isShowJackPotWinPopup = bool;
  }

  setJackPotExpireTime(time) {
    this.jackPotExpireTime = time;
  }

  setJackpotAmounts(jackpotAmounts) {
    this.jackpotAmounts = jackpotAmounts;
    this.jackpotSceneAmounts = this.jackpotAmounts;
  }

  updateJackpotAmounts(jackpotWinCard) {
    this.jackpotAmounts[JACK_POT_AMOUNT_KEY[jackpotWinCard.jackpotCard]] = 0;
    this.jackpotSceneAmounts[JACK_POT_AMOUNT_KEY[jackpotWinCard.jackpotCard]] = 0;
  }

  setJackpotWinInfo(jackpotWinInfo) {
    this.jackpotWinInfo = jackpotWinInfo;
  }

  setJackpotAmountIsVisible(boolValue) {
    this.jackpotAmountIsVisible = boolValue;
  }

  setInitialBonusSpinInfo(initialBonusSpinInfoData) {
    this.initialBonusSpinInfo = initialBonusSpinInfoData;
  }

  setJackpotWinnerInfo(value) {
    const jackPotInfo = value.reduce((acc, current) => {
      acc[current.jackpotCard] = current;
      return acc;
    }, {});
    this.jackpotWinnerInfo = jackPotInfo;
  }

  updateJackpotData(data, isExpireTime = false) {
    const infoData = isExpireTime ? [...data] : [...this.jackPotData, data.jackpotSceneItemInfo];
    isExpireTime
      ? (this.remainingJackpotCards = data)
      : (this.remainingJackpotCards = data.jackpotSceneItemInfos);
    this.jackPotData = infoData;
  }

  showRemainingJackpotCards(isExpireTime = false) {
    isExpireTime
      ? (this.jackPotData = [...this.remainingJackpotCards])
      : (this.jackPotData = [...this.jackPotData, ...this.remainingJackpotCards]);
  }

  setIsExpiredJackpotCards(bool) {
    this.isExpiredJackpotCards = bool;
  }
}

export const jackPotStore = new JackPotStore();
